// Lib
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Utils
import { getElementId } from '../../../../../../common/elements/utils/elementPropertyUtils';

// Actions
import { startEditingMainEditor } from '../../../../../element/selection/selectionActions';

// Components
import ToolbarTool from '../../ToolbarTool';
import Icon from '../../../../../components/icons/Icon';
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import { ToolTypeSettings, ToolbarSettings } from '../../../toolbarTypes';
import { ToolProps } from '../../Tool';
import { labelRenameStart } from '../../../../../../common/labels/labelActions';
import { getSelectedLabelId } from '../../../../../element/labels/labelSelectors';
import { List } from 'immutable';

type Props = ToolProps & {
    selectedElements: List<ImMNElement>;
    toolSettings?: ToolbarSettings;
};

const RenameTool = (props: Props) => {
    const { selectedElements, toolSettings, ...rest } = props;
    const dispatch = useDispatch();
    const selectedLabelId = useSelector(getSelectedLabelId);

    const handleClick = (event: React.MouseEvent) => {
        event.preventDefault();
        const isLabel = (toolSettings as ToolTypeSettings)?.isLabel;

        if (isLabel && selectedLabelId) {
            dispatch(labelRenameStart(selectedLabelId));
            return;
        }

        const element = selectedElements?.first();
        if (!element) return;
        dispatch(startEditingMainEditor(getElementId(element)));
    };

    return (
        <ToolbarTool {...rest} onClick={handleClick} isActive={false}>
            <Icon name="toolbar-rename" />
        </ToolbarTool>
    );
};

export default RenameTool;
